var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section_container",attrs:{"id":"schema"}},[_c('v-container',[_c('default-home-section-title',{attrs:{"title":_vm.titleSection}}),_c('v-img',{staticClass:"mx-auto",attrs:{"width":"100%","src":_vm.imgSchema}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }